import { render, staticRenderFns } from "./success-dialog.vue?vue&type=template&id=2c87affe&"
import script from "./success-dialog.vue?vue&type=script&lang=js&"
export * from "./success-dialog.vue?vue&type=script&lang=js&"
import style0 from "./success-dialog.vue?vue&type=style&index=0&id=2c87affe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports